var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn--grey",on:{"click":function($event){$event.preventDefault();return _vm.addDevice()}}},[_c('span',{staticClass:"plus-icon"},[_vm._v("+")]),_vm._v(" Voeg apparaat toe\n")])}
var staticRenderFns = []

export { render, staticRenderFns }